"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var react_1 = __importDefault(require("react"));
var WarningTriangleFilled_1 = __importDefault(require("../generated/WarningTriangleFilled"));
var WarningCircleFilled_1 = __importDefault(require("../generated/WarningCircleFilled"));
var StatusIndicator = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  left: -3px;\n  top: -8px;\n  z-index: 300;\n  svg {\n    height: 13px;\n    width: 13px};\n  }\n"], ["\n  position: absolute;\n  left: -3px;\n  top: -8px;\n  z-index: 300;\n  svg {\n    height: 13px;\n    width: 13px};\n  }\n"])));
var StatusIndicatorIcon = function (_a) {
    var state = _a.state, theme = _a.theme;
    return (react_1.default.createElement(StatusIndicator, null,
        state === 'warning' && (react_1.default.createElement(WarningTriangleFilled_1.default, { fill: theme.colours.global.warning, "data-test-id": 'map_view_status_warning' })),
        state === 'alert' && (react_1.default.createElement(WarningCircleFilled_1.default, { fill: theme.colours.global.alarm, "data-test-id": 'map_view_status_alarm' }))));
};
exports.default = StatusIndicatorIcon;
var templateObject_1;
//# sourceMappingURL=status-indicator-icon.component.js.map